"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Item_1 = __importDefault(require("./Item"));
var Layout_1 = require("../Layout");
var styles_1 = require("./styles");
var Menu = function () {
    var _a = react_1.useState(false), showMenu = _a[0], setShowMenu = _a[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Layout_1.MenuContainer, null,
            react_1.default.createElement(Item_1.default, { path: "/" }, "Profil"),
            react_1.default.createElement(Item_1.default, { path: "/competences" }, "Comp\u00E9tences"),
            react_1.default.createElement(Item_1.default, { path: "/projets" }, "Projets"),
            react_1.default.createElement(Item_1.default, { path: "/experiences" }, "Exp\u00E9riences")),
        react_1.default.createElement(styles_1.BurgerMenuContainer, null,
            react_1.default.createElement(styles_1.MenuButton, { onClick: function () { return setShowMenu(!showMenu); } },
                react_1.default.createElement(styles_1.LogoBurgerMenu, { show: showMenu }))),
        showMenu && (react_1.default.createElement(styles_1.OverlayMenu, { onClick: function () { return setShowMenu(false); } },
            react_1.default.createElement(Item_1.default, { path: "/" }, "Profil"),
            react_1.default.createElement(Item_1.default, { path: "/competences" }, "Comp\u00E9tences"),
            react_1.default.createElement(Item_1.default, { path: "/projets" }, "Projets"),
            react_1.default.createElement(Item_1.default, { path: "/experiences" }, "Exp\u00E9riences")))));
};
exports.default = Menu;
